import SubHeader from "../../SubHeader"
const OSRHeader = ({orienteeName, shiftDate, onSaveClose}) => {
    return (
        <SubHeader title1="Orientee" title2="Assessment Report" icon="fa-clipboard-user" compact>
            <div className="d-flex flex-row flex-grow-1 justify-content-end align-items-center gap-3">
                <div className="d-flex flex-column text-dark fw-bold fs-5">
                    <span className="text-gray-700">{orienteeName}</span>
                    {shiftDate?.toLocaleDateString("en-US")}
                </div>
                {onSaveClose && (
                    <button className="btn btn-light-primary btn-sm ms-2" onClick={onSaveClose}>
                        Save/Close
                    </button>
                )}
            </div>
        </SubHeader>
    )
}

export default OSRHeader
